import PropTypes from 'prop-types';
import React from 'react';

import {
    AdSlot,
} from 'reaxl-ads';

function AtcAdSlot({
    className = 'margin-horizontal-auto margin-bottom-4',
    lazyLoadingBottomOffset = '-300',
    lazyLoadingTopOffset = '-300',
    advertisementLabel = {
        className: 'text-right text-size-5',
        text: 'Advertisement',
    },
    showLabel = true,
    showPlaceholder = true,
    isGlobalAdsPlaceholderOff = false,
    ...rest
}) {
    return (
        <AdSlot
            advertisementLabel={showLabel ? advertisementLabel : { className: 'hidden' }}
            extra={{
                'data-qa-data': JSON.stringify(rest),
            }}
            showPlaceholder={showPlaceholder && !isGlobalAdsPlaceholderOff}
            {...{ lazyLoadingBottomOffset, lazyLoadingTopOffset, className, ...rest }}
        />
    );
}

AtcAdSlot.propTypes = {
    advertisementLabel: PropTypes.object,
    className: PropTypes.string,
    extra: PropTypes.object,
    lazyLoading: PropTypes.bool,
    lazyLoadingBottomOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lazyLoadingTopOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    showLabel: PropTypes.bool,
    size: PropTypes.array.isRequired,
    slotId: PropTypes.string.isRequired,
    showPlaceholder: PropTypes.bool,
};

export default AtcAdSlot;
